import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TimePeriodRecentPerformance } from '../constants/time-periods-recent-performance';

@Pipe({ name: 'timePeriodDisplayText' })
@Injectable({ providedIn: 'root' })
export class TimePeriodDisplayTextPipe implements PipeTransform {
    transform(period: string): string {
        if (!period) {
            return '';
        }

        return this.updateTimePeriodDisplayText(period);
    }

    private updateTimePeriodDisplayText(timePeriod: string): string {
        const formatDate = (date: Date): string => {
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            });
        };

        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);

        if (timePeriod === TimePeriodRecentPerformance.Current) {
            return formatDate(currentDate);
        }

        const startDate = new Date(currentDate);

        if (timePeriod === TimePeriodRecentPerformance.Last7Days) {
            startDate.setDate(startDate.getDate() - 6);
        } else {
            startDate.setDate(startDate.getDate() - 29);
        }

        return `${formatDate(startDate)} - ${formatDate(currentDate)}`;
    }
}
